export const WA_NUMBER = "5511941546532";
export const WA_DISPLAY = "(11) 94154-6532";
export const INSTAGRAM = "drguilherme.affonso";

export const waLink = (message) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(message)}`;

export const LP_WA_MESSAGE =
  "Olá! Vim pela página de emagrecimento da AEVOS e gostaria de agendar uma consulta com o Dr. Guilherme.";

export const DOCTOR = {
  name: "Dr. Guilherme Affonso",
  specialty: "Especialista em Medicina Preventiva e Social",
  crm: "CRM-SP 200364 | RQE 120948",
  attendance: "Atendimento presencial em Mogi das Cruzes e online.",
};

export const PAIN_ITEMS = [
  "Dificuldade para perder peso após diferentes tentativas",
  "Recuperação do peso perdido",
  "Dietas restritivas difíceis de manter",
  "Rotina corrida que atrapalha a alimentação e os exercícios",
  "Dúvidas sobre o que faz sentido para o seu caso",
  "Falta de acompanhamento para ajustar o plano ao longo do tempo",
];

export const CREDENTIALS = [
  "Graduação em Medicina pela Universidade de Mogi das Cruzes",
  "Residência em Medicina Preventiva e Social pelo Hospital Sírio-Libanês",
  "Médico responsável pela AEVOS",
];

export const CONSULTA_CARDS = [
  {
    title: "Sua história e suas tentativas anteriores",
    text: "Conversa sobre saúde, objetivos, dificuldades e estratégias que você já tentou para emagrecer.",
  },
  {
    title: "Sua rotina e seus hábitos",
    text: "Avaliação da alimentação, do sono e da atividade física, considerando o que você consegue colocar em prática no dia a dia.",
  },
  {
    title: "Exames e composição corporal",
    text: "Análise dos exames disponíveis e avaliação da necessidade de recursos complementares para entender melhor seu caso.",
  },
  {
    title: "Direcionamento personalizado",
    text: "Explicação dos principais achados, definição de prioridades e orientação sobre as possibilidades de tratamento e acompanhamento.",
  },
];

export const EXAM_CARDS = [
  {
    title: "Calorimetria indireta em Mogi das Cruzes",
    image: "/assets/lp-calorimetria.jpg",
    alt: "Exame de calorimetria indireta na AEVOS — paciente com máscara e monitor de gasto energético",
    lead: "Entenda quanto seu corpo gasta de energia em repouso.",
    text: "A calorimetria indireta avalia o gasto energético em repouso por meio da análise dos gases da respiração. Essa informação pode contribuir para o planejamento nutricional, junto à avaliação clínica e à sua rotina.",
  },
  {
    title: "Avaliação da composição corporal por ultrassom",
    image: "/assets/lp-bodymetrix.jpg",
    alt: "Aparelho BodyMetrix BX 2000 para avaliação da composição corporal por ultrassom",
    lead: "Acompanhe mudanças que o peso na balança não mostra sozinho.",
    text: "A avaliação com o BodyMetrix utiliza ultrassom para medir a espessura da gordura em pontos do corpo e estimar o percentual de gordura corporal. Esses dados podem complementar a avaliação inicial e o acompanhamento do emagrecimento.",
  },
];

export const DIFERENCIAIS = [
  "Avaliação que considera sua saúde, seu histórico e suas dificuldades",
  "Objetivos definidos de acordo com seu momento e suas necessidades",
  "Orientações que levam em conta sua rotina",
  "Explicação clara sobre exames e possibilidades de tratamento",
  "Integração com nutrição e exercício físico, quando necessária",
  "Possibilidade de acompanhamento contínuo para avaliar a evolução e ajustar a estratégia",
];

export const ETAPAS = [
  {
    title: "Compreender seu ponto de partida",
    text: "Organizar as informações sobre sua saúde, composição corporal, hábitos e objetivos.",
  },
  {
    title: "Definir uma estratégia",
    text: "Estabelecer prioridades e orientações individualizadas, com integração de outros profissionais quando indicada.",
  },
  {
    title: "Acompanhar e ajustar",
    text: "Reavaliar sua resposta ao cuidado, conversar sobre as dificuldades e fazer os ajustes necessários ao longo do processo.",
  },
];

export const REVIEWS = [
  {
    initials: "TB",
    name: "Tati Bueno",
    role: "Mogi das Cruzes",
    text: "Em apenas 3 meses, o Dr. Guilherme transformou meus resultados de forma mais expressiva do que em 8 anos de treinos. Sem fórmulas mágicas — acompanhamento individualizado, alinhando dieta, protocolo e exames constantes, sempre com foco na minha saúde.",
  },
  {
    initials: "IN",
    name: "Ismael Nogueira",
    role: "São Paulo",
    text: "Finalmente encontrei um médico que me ouviu de verdade. A abordagem preventiva e personalizada da AEVOS é diferente de tudo que já vi. Hoje consigo treinar melhor, dormir melhor e o rendimento no trabalho melhorou muito.",
  },
  {
    initials: "CM",
    name: "Chrys Moura",
    role: "Mogi das Cruzes",
    text: "Excelente acompanhamento. Sua dedicação, orientação e profissionalismo foram fundamentais para a melhora da minha performance, redução do percentual de gordura e ganho de massa magra. Muito obrigada por todo o suporte durante essa jornada!",
  },
];

export const FAQ = [
  {
    q: "Preciso ter obesidade para procurar atendimento?",
    a: "Você pode procurar uma avaliação para conversar sobre dificuldades com o peso, composição corporal e saúde metabólica. A consulta ajuda a entender se há indicação de tratamento e quais objetivos são adequados ao seu caso.",
  },
  {
    q: "Já tentei várias dietas. Como funciona essa avaliação?",
    a: "O Dr. Guilherme considera suas tentativas anteriores, suas dificuldades, seu histórico de saúde e sua rotina. Essas informações ajudam a definir prioridades e orientar uma estratégia individualizada.",
  },
  {
    q: "Como funciona a primeira consulta?",
    a: "A consulta inclui avaliação do histórico clínico, dos hábitos, dos objetivos e dos exames disponíveis. A partir dessas informações, são discutidos os principais achados e as possibilidades de cuidado.",
  },
  {
    q: "Preciso levar exames?",
    a: "Se você tiver exames anteriores, leve-os para avaliação. A necessidade de novos exames será definida durante a consulta.",
  },
  {
    q: "Para que serve a calorimetria indireta?",
    a: "Ela avalia o gasto energético em repouso por meio da análise dos gases da respiração. O resultado pode ajudar no planejamento nutricional, considerando também sua saúde, sua rotina e seus objetivos.",
  },
  {
    q: "A calorimetria é um exame para saber como está meu metabolismo?",
    a: "Ela avalia uma parte desse contexto: o gasto energético em repouso. A avaliação metabólica é mais ampla e pode considerar histórico clínico, hábitos e outros exames, conforme a necessidade.",
  },
  {
    q: "Como funciona a avaliação corporal com BodyMetrix?",
    a: "O aparelho utiliza ultrassom para medir a espessura da gordura em pontos do corpo e estimar o percentual de gordura corporal. A avaliação pode ajudar a acompanhar mudanças na composição corporal ao longo do cuidado.",
  },
  {
    q: "Os exames e o atendimento com nutricionista estão incluídos na consulta?",
    a: "A consulta inicial é uma avaliação médica. A realização de exames e a participação de outros profissionais dependem da necessidade individual e da modalidade de acompanhamento. A equipe informa o que está incluído e os respectivos valores antes do agendamento.",
  },
  {
    q: "Vou precisar fazer acompanhamento?",
    a: "A recomendação depende da avaliação inicial. Quando indicado, o acompanhamento permite reavaliar sua evolução e ajustar as orientações conforme sua resposta e suas dificuldades.",
  },
  {
    q: "Quanto custa a consulta inicial?",
    a: "O investimento na Consulta Médica Individualizada AEVOS é de R$ 600. Informações sobre modalidades de acompanhamento podem ser obtidas com a equipe.",
  },
  {
    q: "Posso fazer a consulta online?",
    a: "Sim. Há atendimento online e presencial em Mogi das Cruzes. As avaliações com equipamentos são presenciais, e a equipe orienta sobre a organização de cada atendimento.",
  },
  {
    q: "Em quanto tempo vou emagrecer?",
    a: "O ritmo e a resposta ao tratamento variam de pessoa para pessoa. Os objetivos são discutidos após a avaliação e revistos durante o acompanhamento, sem previsão de perda de peso igual para todos.",
  },
  {
    q: "Já uso ou penso em usar medicamentos para emagrecer. Posso fazer uma avaliação?",
    a: "Sim. A avaliação médica ajuda a entender seu histórico, sua saúde atual, seus objetivos e se existe indicação para algum tipo de tratamento. Caso você já esteja utilizando alguma medicação, o médico também poderá avaliar como está sendo esse uso, sempre de forma individualizada e segura.",
  },
  {
    q: "Quem pode avaliar meu caso para tratamento de emagrecimento?",
    a: "O ideal é passar por uma avaliação médica completa. Na consulta, são analisados fatores como histórico de saúde, composição corporal, exames, rotina, hábitos e objetivos. A partir disso, o médico pode definir quais estratégias fazem sentido para o seu caso e acompanhar sua evolução ao longo do tratamento.",
  },
];

export const GOOGLE_BUSINESS_URL = "https://share.google/TwxmohMhRZZKGxfHv";

export const ADDRESS = {
  street: "Rua Waldemar Zierold, 23 — Vila Sarah Avignon",
  city: "Mogi das Cruzes — SP",
  cep: "CEP 08773-470",
  mapsEmbed:
    "https://www.google.com/maps?q=Rua+Waldemar+Zierold,+23,+Vila+Sarah+Avignon,+Mogi+das+Cruzes+-+SP,+08773-470&output=embed",
};
